import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import SeasonalContact from './SeasonalContact';
import reportWebVitals from './reportWebVitals';
import MatchdayHospitality from './MatchdayHospitality';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/seasonal-contact" element={<SeasonalContact />} />
        <Route path="/matchday-hospitality" element={<MatchdayHospitality />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();
